import { createFileRoute, redirect } from "@tanstack/react-router";

// URL antigua: redirección permanente a la ruta limpia.
export const Route = createFileRoute("/en/grants/")({
  beforeLoad: () => {
    throw redirect({ to: "/en/resources/subsidies", statusCode: 301 });
  },
});
